#import "./RecordingBlobDetails.graphql"
query PracticeRecordingContents($id: ID!) {
  practiceRecordingContents(id: $id) {
    ...recordingBlobDetails
  }
}
